import React from 'react';
import PropTypes from 'prop-types';
import AudioTracksContainer from '../Video/AudioTracksContainer';
import TileView from './TileView';
import Filmstrip from './Filmstrip';
import EmptyFilmstrip from './EmptyFilmstrip';
import withBoundary from 'component/ErrorBoundary/withBoundary';
import { connect } from 'store/modules/base/redux';
import {
  getParticipantById,
  getVideoDeviceParticipants
} from 'store/modules/base/participants';
import { shouldDisplayTileView } from 'store/modules/video-layout';

const RemoteFilmstrip = (props) => {
  const {
    _tileViewActive,
    _isEmptyStageView,
    _remoteParticipants,
    _deviceParticipants,
    _stageParticipants,
    _clientHeight,
    _clientWidth,
    _visible,
    visible
  } = props;
  return (
    _visible && (
      <div
        className={`filmstrip ${_isEmptyStageView ? 'empty-filmstrip' : ''}`}
        style={_isEmptyStageView ? { height: window.thumbnailHeight } : {}}>
        {_tileViewActive ? (
          <TileView stageParticipants={_stageParticipants} />
        ) : _isEmptyStageView && visible ? (
          <EmptyFilmstrip
            deviceParticipants={_deviceParticipants}
            remoteParticipants={_remoteParticipants}
            clientHeight={_clientHeight}
            clientWidth={_clientWidth}
          />
        ) : (
          visible && (
            <Filmstrip
              deviceParticipants={_deviceParticipants}
              remoteParticipants={_remoteParticipants}
            />
          )
        )}
        <AudioTracksContainer />
      </div>
    )
  );
};
/**
 * Maps (parts of) the Redux state to the associated {@code DeviceFilmstrip}'s props.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {Props}
 */
function _mapStateToProps(state) {
  const tileViewActive = shouldDisplayTileView(state);
  const isAudioActive = state['features/filmstrip'].isAudioActive;
  const { clientWidth, clientHeight } = state['features/base/responsive-ui'];

  // const participants = Array.from(
  //   getRemoteParticipants(state),
  //   // eslint-disable-next-line no-unused-vars
  //   ([name, value]) => value
  // );
  const { remoteParticipants } = state['features/filmstrip'];
  const dParticipants = [],
    rParticipants = [],
    allParticipants = [];
  remoteParticipants.forEach((item) => {
    const p = getParticipantById(state, item);

    if (p && !p.local && !p.fakeParticipant && item !== 'local') {
      p.status === '1' || p.status === 1
        ? rParticipants.push(item)
        : dParticipants.push(item);
      allParticipants.push(item);
    }
  });
  const deviceParticipants = getVideoDeviceParticipants(state);
  return {
    _remoteParticipants: rParticipants,
    _deviceParticipants: dParticipants,
    _stageParticipants: allParticipants,
    _visible: allParticipants.length > 0,
    _tileViewActive: tileViewActive,
    _isEmptyStageView:
      tileViewActive || isAudioActive ? false : deviceParticipants.length <= 0,
    _isAudioActive: isAudioActive,
    _clientWidth: clientWidth,
    _clientHeight: clientHeight
  };
}
export default React.memo(
  connect(_mapStateToProps)(withBoundary(RemoteFilmstrip))
);
RemoteFilmstrip.propTypes = {
  _remoteParticipants: PropTypes.array,
  _deviceParticipants: PropTypes.array,
  _stageParticipants: PropTypes.array,
  _tileViewActive: PropTypes.bool,
  _isAudioActive: PropTypes.bool,
  _isEmptyStageView: PropTypes.bool,
  _visible: PropTypes.bool,
  visible: PropTypes.bool,
  _clientWidth: PropTypes.number,
  _clientHeight: PropTypes.number
};
